export const MIN_DISTANCE_TO_STORE = 50;
